/** Each event owns its timeout; retries retain the exact UUID and expected revision.
 * A timeout does not imply rollback: a committed response may have been lost. */
export async function sendRacquetEvent(
  post,
  path,
  event,
  { timeoutMs = 15000, signal, requestId, decode = (value) => value } = {}
) {
  const controller = new AbortController()
  let timer, abort
  const stop = () =>
    controller.abort(
      signal?.reason || new DOMException('Cancelled', 'AbortError')
    )
  const cancelled = new Promise((_, reject) => {
    abort = () => reject(controller.signal.reason)
    controller.signal.addEventListener('abort', abort, { once: true })
    timer = setTimeout(
      () =>
        controller.abort(new DOMException('Saving timed out', 'TimeoutError')),
      timeoutMs
    )
  })
  signal?.addEventListener('abort', stop, { once: true })
  if (signal?.aborted) stop()
  try {
    return await Promise.race([
      Promise.resolve()
        .then(() => post(path, event, { signal: controller.signal, ...(requestId ? { headers: { 'X-Privana-Request-Id': requestId } } : {}) }))
        .then(decode),
      cancelled
    ])
  } finally {
    clearTimeout(timer)
    signal?.removeEventListener('abort', stop)
    controller.signal.removeEventListener('abort', abort)
  }
}
